import { useMemo } from "react";
import { soortenWithOverrides, type Soort } from "@/lib/catalog";
import { useCatalogOverrides } from "@/lib/catalog-overrides";

/**
 * Soorten mét de live admin-overrides (uitgeschakeld weg, "vanaf"-prijs aangepast), reactief.
 * Geef een productSlug om te filteren. Vervangt `getSoorten()` in de overzichten/grids zodat
 * een in de admin uitgezette soort ook daar verdwijnt en prijswijzigingen overal kloppen.
 */
export function useSoorten(productSlug?: string): Soort[] {
  const ov = useCatalogOverrides();
  return useMemo(() => {
    const all = soortenWithOverrides(ov);
    return productSlug ? all.filter((s) => s.productSlug === productSlug) : all;
  }, [ov, productSlug]);
}
